const schema = {
  type: 'Object',
  contents: {
    key: {
      label: '單品編碼',
      type: 'String',
      unique: true,
      required: true,
    },
    barcode: {
      label: '單品條碼',
      type: 'String',
    },
    productRef: {
      label: '商品型號',
      type: 'ObjectId',
      reference: 'products',
      // required: true,
      refKeys: ['key'],
      view: 'main',
    },
    spec: {
      label: '規格',
      type: 'Object',
      contents: {
        skuSizeRef: {
          label: '尺寸',
          type: 'ObjectId',
          reference: 'skuSizes',
          refKeys: ['key'],
        },
        skuColorRef: {
          label: '色碼',
          type: 'ObjectId',
          reference: 'skuColors',
          refKeys: ['key', 'name'],
        },
      },
    },
    '@suspended': {
      type: 'Boolean',
      label: '停用',
    },
  },
}

export default schema
